<div class="layout py-12">
  <h2 class="font-bold text-4xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'joinUs' | translate }}
  </h2>
</div>
<div class="layout py-12 bg-beige">
  <h3 class="font-bold mb-9 text-3xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'joinUs.1.title' | translate }}
  </h3>
  <div class="flex gap-6 justify-center items-start">
    <div class="hidden md:block relative grow aspect-1">
      <img alt="" class="object-cover rounded-lg" fill="" loading="lazy"
           ngSrc="assets/images/rh/rh-13.webp">
    </div>
    <div class="relative grow aspect-1">
      <img alt="" class="object-cover rounded-lg" fill="" loading="lazy"
           ngSrc="assets/images/rh/rh-4.webp">
    </div>
    <div class="hidden md:block relative grow aspect-1">
      <img alt="" class="object-cover rounded-lg" fill="" loading="lazy"
           ngSrc="assets/images/rh/rh-14.webp">
    </div>
  </div>
  <div class="flex flex-row justify-evenly mt-7">
    <div class="font-semibold text-base md:text-2xl text-gray-500">{{ 'joinUs.slogan.2' | translate }}</div>
  </div>
  <div class="basis-full md:basis-1/2 flex flex-col">
    <a appHoverGradient
       class="big-btn py-4 mb-6 text-md flex justify-center items-center"
       routerLink="/careers">
      {{ 'seeOurOffers' | translate }}
    </a>
  </div>
</div>
<div class="layout py-12">
  <h2 class="font-bold mb-9 text-3xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'joinUs.3.title' | translate }}
  </h2>
  <div class="flex flex-col md:flex-row gap-4 mt-4 md:mt-8 items-stretch">
    @for (step of steps; track step; let first = $first) {
      <div class="basis-1/4 bg-bleuCaliceo-300 rounded-lg p-6 flex flex-col">
        <h3
          class="text-xl uppercase font-semibold text-white">{{ 'joinUs.step' | translate }} {{ step }}</h3>
        <p class="text-sm mt-3 text-white grow">
          @if (first) {
            <a class="underline cursor-pointer"
               routerLink="/careers">{{ 'joinUs.step.' + step + '.title' | translate }}</a>
          } @else {
            {{ 'joinUs.step.' + step + '.title' | translate }}
          }
        </p>
      </div>
    }
  </div>
</div>
<div class="layout py-12 bg-beige">
  <h2 class="font-bold mb-9 text-3xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'joinUs.2.title' | translate }}
  </h2>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 py-6 md:py-12 items-start">
    <div class="w-full md:order-1">
      <div class="relative w-full overflow-hidden pt-[56.25%]">
        <p>
          <iframe
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            class="absolute top-0 bottom-0 left-0 right-0 w-full h-full border-none" frameborder="0"
            height="315" referrerpolicy="strict-origin-when-cross-origin"
            src="https://www.youtube.com/embed/rGbapkp2_qI?si=-Kf0f13-zMruBeBk"
            title="YouTube video player" width="560"></iframe>
        </p>
      </div>
    </div>
    <p class="md:order-3 text-gray-500 text-md font-bold text-center mb-4">
      {{ 'joinUs.2.counter' | translate }}
    </p>
    <div class="w-full md:order-2">
      <div class="relative w-full overflow-hidden pt-[56.25%]">
        <p>
          <iframe
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            class="absolute top-0 bottom-0 left-0 right-0 w-full h-full border-none" frameborder="0"
            height="315" referrerpolicy="strict-origin-when-cross-origin"
            src="https://www.youtube.com/embed/zS9L-F82B0s?si=sgW1mb1YNdAwYvB1"
            title="YouTube video player" width="560"></iframe>
        </p>
      </div>
    </div>
    <p class="md:order-4 text-gray-500 text-md font-bold text-center mb-4">
      {{ 'joinUs.2.spa' | translate }}
    </p>
    <div class="w-full md:order-5 md:col-span-2">
      <div class="relative w-full md:w-1/2 mx-auto overflow-hidden pt-[56.25%] md:pt-[28.125%]">
        <p>
          <iframe
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            class="absolute top-0 bottom-0 left-0 right-0 w-full h-full border-none" frameborder="0"
            height="315" referrerpolicy="strict-origin-when-cross-origin"
            src="https://www.youtube.com/embed/eOZk4GRuF48?si=oy9NRxuN08oabs9n"
            title="YouTube video player" width="560"></iframe>
        </p>
      </div>
    </div>
    <p class="md:order-7 md:col-span-2 text-gray-500 text-md font-bold text-center mb-4">
      {{ 'joinUs.2.swimcoach' | translate }}
    </p>
  </div>
</div>
<div class="layout py-12">
  <h2 class="font-bold mb-9 text-3xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'joinUs.4.title' | translate }}
  </h2>
  <p class="font-medium text-gray-500 text-md whitespace-pre-line">
    {{ 'joinUs.4.description2' | translate }}
  </p>

  <div class="grid grid-cols-1 gap-x-6 gap-y-2 py-6 md:py-12 items-start">
    <div class="w-full">
      <div class="relative w-full overflow-hidden pt-[56.25%]">
        <p>
          <iframe
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            class="absolute top-0 bottom-0 left-0 right-0 w-full h-full border-none" frameborder="0"
            height="315" referrerpolicy="strict-origin-when-cross-origin"
            src="https://www.youtube.com/embed/tysugPHG0oY?si=3yexOBrbzq1x2jex"
            title="YouTube video player" width="560"></iframe>
        </p>
      </div>
    </div>
  </div>
  <p class="font-medium text-gray-500 text-md whitespace-pre-line">
    {{ 'joinUs.4.description' | translate }}
  </p>
</div>
